import { useEffect, useState } from 'react';

export function useCountdown(totalSeconds: number) {
  const [remaining, setRemaining] = useState(totalSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((r) => (r <= 1 ? totalSeconds : r - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [totalSeconds]);

  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  return { h: pad(h), m: pad(m), s: pad(s) };
}

function pad(n: number) {
  return String(n).padStart(2, '0');
}
